<template>
  <div>
    <!-- 新增按钮 -->

    <Input
      v-model="searchId"
      placeholder="输入用户ID"
      style="width: 200px; margin-right: 10px"
    />

    <Input
      v-model="searchCouriernum"
      placeholder="输入快递单号"
      style="width: 200px; margin-right: 10px"
    />

    <DatePicker
      v-model="searchDate"
      type="daterange"
      placement="bottom-end"
      placeholder="选择发货时间"
      style="width: 200px; margin-right: 10px"
    ></DatePicker>

    <Button type="primary" @click="queryGoods">查询</Button>

    <Table :columns="columns10" :data="data9"> </Table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right">
        <Page
          :total="total"
          :current="current"
          :page-size="50"
          @on-change="changePage"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="returnModal"
      title="提示?"
      @on-ok="returnModalOk"
      @on-cancel="returnModal = false"
    >
      <p>确认将以发货订单追回吗?</p>
    </Modal>

    <Modal
      v-model="updateCourierModal"
      title="修改快递单号"
      :footer-hide="true"
      @on-cancel="updateCourierModalCancel"
    >
      <Input
        v-model="updateCouriernum"
        placeholder="请填写快递单号"
        style="width: 200px"
      />

      <div style="text-align: right; margin-top: 16px">
        <Button style="margin-right: 8px" @click="updateCourierModalCancel">取消</Button>
        <Button
          type="primary"
          :loading="updateCourierSaving"
          @click="updateCourierConfirmAndSave"
        >
          确认并保存
        </Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import SingleUpload from "@/components/Upload/singleUpload";
import { cmsSelYiShopOrder, cmsUpdateOrder, cmsUpdateOrderZhuihui } from "../../api/fahuo";
import expandRow from "./fahuolist_expand.vue";

export default {
  components: { expandRow, SingleUpload },
  data() {
    return {
      couriernumModal: false,
      couriernum: "",
      goodstypeOptions: this.$goodsTypeOptions,
      selectedRows: [], // 用于保存选中的行
      returnModal: false,
      updateCourierModal: false,
      updateCouriernum: "",
      updateCourierSaving: false,
      returnreasonIDs: [],
      selectedReturn: "",
      returnnum: "",
      loading: false,
      searchDate: [],
      data9: [], // 用于存储查询结果
      columns10: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(expandRow, {
              props: {
                row: params.row,
              },
            });
          },
        },

        {
          title: "订单号",
          key: "ordernum",
        },
        {
          title: "总成本",
          key: "cost",
        },
        {
          title: "碎片数量",
          key: "goodsnum",
        },

        {
          title: "用户id",
          key: "user_id",
        },

        {
          title: "用户手机号",
          key: "user_phone",
        },
        {
          title: "用户地址",
          key: "user_address",
        },
        {
          title: "备注",
          key: "remarks",
        },
        {
          title: "申请时间",
          key: "createtime",
        },
        {
          title: "发货单号",
          key: "couriernum",
        },
        {
          title: "发货时间",
          key: "deliverytime",
        },
        {
          title: "发货状态",
          key: "deliverytime",
          render: (h, params) => {
            const ordertype = params.row.ordertype;

            return h("span", ordertype === 1 ? "已发货" : "发货追回");
          },
        },
        {
          title: "操作",
          key: "action",
          width: 280,
          align: "center",
          render: (h, params) => {
            // 判断逻辑：如果 params.row.rows 中的 procurestatus 都等于 1

            return h("div", [
              // 根据判断结果渲染按钮

              parseInt(params.row.ordertype) == 1
                ? h("div", [
                    h(
                      "Button",
                      {
                        props: {
                          type: "primary",
                          size: "small",
                        },
                        style: {
                          marginRight: "5px",
                        },
                        on: {
                          click: () => {
                            this.openUpdateCourierModal(params.row.rows, params.row.couriernum);
                          },
                        },
                      },
                      "修改快递单"
                    ),
                    h(
                      "Button",
                      {
                        props: {
                          type: "primary",
                          size: "small",
                        },
                        on: {
                          click: () => {
                            this.returnOrder(params.row.rows);
                          },
                        },
                      },
                      "订单追回"
                    ),
                  ])
                : null,
            ]);
          },
        },
      ],
      searchId: "",
      searchCouriernum: "",
      searchName: "",
      searchType: "",
      current: 1,
      total: 0,
    };
  },

  mounted() {
    this.queryGoods();
    // 添加延时函数，等待数据加载完成后手动展开所有行
    setTimeout(() => {
      const expandButtons = document.querySelectorAll('.ivu-table-cell-expand .ivu-icon');
      expandButtons.forEach(btn => {
        // 检查是否已经展开
        if (btn.classList.contains('ivu-icon-ios-arrow-right')) {
          btn.click(); // 触发点击事件展开行
        }
      });
    }, 1000); // 延迟1秒执行，确保数据已加载
  },
  methods: {
    openUpdateCourierModal(data, couriernum) {
      var arr = [];
      for (let i = 0; i < data.length; i++) {
        arr.push(data[i]);
      }
      this.returnreasonIDs = arr;
      this.updateCouriernum = couriernum || "";
      this.updateCourierModal = true;
    },
    updateCourierModalCancel() {
      this.updateCourierModal = false;
      this.updateCouriernum = "";
      this.updateCourierSaving = false;
    },
    updateCourierConfirmAndSave() {
      if (!(this.updateCouriernum && this.updateCouriernum.length > 0)) {
        this.$Message.error("请输入快递单号");
        return;
      }
      if (this.updateCourierSaving) return;

      this.updateCourierSaving = true;
      cmsUpdateOrder({
        items: this.returnreasonIDs,
        couriernum: this.updateCouriernum,
      })
        .then((res) => {
          this.$Message.success("修改快递单号成功");
          this.updateCourierModalCancel();
          this.queryGoods();
        })
        .finally(() => {
          this.updateCourierSaving = false;
        });
    },
    returnOrder(data) {
      console.log("data", data);
      this.returnModal = true;
      var arr = [];
      for (let i = 0; i < data.length; i++) {
        arr.push(data[i]);
      }
      this.returnreasonIDs = arr;
    },
    returnModalOk() {
      cmsUpdateOrderZhuihui({
        items: this.returnreasonIDs,
      }).then((res) => {
        this.queryGoods(); // 直接调用查询函数，不用重复逻辑
      });
    },
    // 查询商品
    // 公共查询函数
    fetchGoodsData(params = {}) {
      cmsSelYiShopOrder(params)
        .then((response) => {
          this.data9 = response.data.rows; // 获取查询结果
          this.current = response.data.pagination.page; // 获取当前页
          this.total = response.data.pagination.total; // 获取总数
        })
        .catch((error) => {
          console.error(error);
        });
    },

    // 查询商品
    queryGoods() {
      var starttime = "";
      var endtime = "";
      if (this.searchDate.length > 0 && this.searchDate[0] != "") {
        starttime = this.formatDate(this.searchDate[0]);
        endtime = this.formatDate(this.searchDate[1]);
      }
      const params = {
        user_id: this.searchId || undefined,
        couriernum: this.searchCouriernum || undefined,
        goodsname: this.searchName || undefined,
        goodstype: this.searchType || undefined,
        starttime,
        endtime,
        page: this.current,
      };
      this.fetchGoodsData(params);
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    // 分页查询
    changePage(e) {
      this.current = e;
      this.queryGoods(); // 直接调用查询函数，不用重复逻辑
    },
  },
};
</script>
